import { render, staticRenderFns } from "./PurchaseInfo.vue?vue&type=template&id=39c62393&scoped=true"
import script from "./PurchaseInfo.vue?vue&type=script&lang=ts"
export * from "./PurchaseInfo.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseInfo.vue?vue&type=style&index=0&id=39c62393&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c62393",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39c62393')) {
      api.createRecord('39c62393', component.options)
    } else {
      api.reload('39c62393', component.options)
    }
    module.hot.accept("./PurchaseInfo.vue?vue&type=template&id=39c62393&scoped=true", function () {
      api.rerender('39c62393', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/PurchaseInfo.vue"
export default component.exports